import { LAST_PATH_KEY } from 'store/user'
import { getInitialLocation, isRememberableLastPath } from 'router/locationUtils'

// ------------------------------------
// Constants
// ------------------------------------
export const LOCATION_CHANGE = 'LOCATION_CHANGE'

// ------------------------------------
// Actions
// ------------------------------------
export function locationChange(location = '/') {
  return {
    type: LOCATION_CHANGE,
    payload: location,
  }
}

// ------------------------------------
// Specialized Action Creator
// ------------------------------------
export const updateLocation = ({ dispatch, getState }) => {
  return nextLocation => {
    dispatch(locationChange(nextLocation))
    const user = getState()?.user
    if (user?.id && isRememberableLastPath(nextLocation?.pathname)) {
      try {
        localStorage.setItem(LAST_PATH_KEY, nextLocation.pathname)
      } catch (e) {
        // ignore storage errors
      }
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = getInitialLocation()
export default function locationReducer(state = initialState, action) {
  if (action.type !== LOCATION_CHANGE) return state

  const payload = action.payload || {}
  const pathname = payload.pathname
  const search = payload.search || ''
  const hash = payload.hash || ''
  if (pathname === state.pathname && (state.search || '') === search && (state.hash || '') === hash) {
    return state
  }

  return {
    ...payload,
    prevPathname: pathname !== state.pathname ? state.pathname : pathname,
  }
}
